module.exports = __webpack_public_path__ + "static/media/dmvi_white.75e2ff4c.png";